import BaseObjectStore from './base-object.store';

class ReadinessRecoveryStore extends BaseObjectStore {
  constructor(props) {
    super(props);
    this.name = 'readinessRecovery';
  }

  resetAllFields() {
    this.resetAllBaseFields();
  }
}

export default new ReadinessRecoveryStore();
